module.exports = __webpack_public_path__ + "img/icn_interview_checked.a8d3445a.svg";